import { render, staticRenderFns } from "./post-boost.vue?vue&type=template&id=202c448c&"
import script from "./post-boost.vue?vue&type=script&lang=js&"
export * from "./post-boost.vue?vue&type=script&lang=js&"
import style0 from "./post-boost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports